import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { Field, reduxForm, change } from "redux-form";
import { getInspection, uploadReportPhoto, deleteReportPhoto } from "../Reducers/actions";
import { renderField, renderTextField } from "../../../Components/Forms/renders";
import SwitcButton from "../../../Components/Forms/switch";
import "./execute.css";

// Global helper for photo uploads
const uploadPhotoToServer = async (file) => {
  if (!file) return null;

  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch('/api/inspections/upload-photo', {
      method: 'POST',
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      return data.result;
    } else {
      throw new Error(data.message || 'Upload failed');
    }
  } catch (error) {
    console.error('Error uploading photo:', error);
    alert('Fout bij uploaden foto: ' + error.message);
    return null;
  }
};

// Custom field renderers for special templates
const renderSchaaldDelenField = ({ input, meta, templateId }) => {
  const value = input.value || { rows: [] };
  const rows = value.rows || [];

  const handleAddRow = () => {
    const newRow = {
      item_number: rows.length + 1,
      status_droog: '',
      photo_droog: [],
      status_nat: '',
      photo_nat: []
    };
    input.onChange({
      ...value,
      rows: [...rows, newRow]
    });
  };

  const handleRemoveRow = (rowIndex) => {
    const newRows = rows.filter((_, idx) => idx !== rowIndex);
    const renumberedRows = newRows.map((row, idx) => ({
      ...row,
      item_number: idx + 1
    }));
    input.onChange({
      ...value,
      rows: renumberedRows
    });
  };

  const handleRowChange = (rowIndex, field, fieldValue) => {
    const newRows = [...rows];
    newRows[rowIndex] = {
      ...newRows[rowIndex],
      [field]: fieldValue
    };
    input.onChange({
      ...value,
      rows: newRows
    });
  };

  return (
    <div className="schaal-delen-form">
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead className="thead-light">
            <tr>
              <th style={{ width: '8%' }} rowSpan="2" className="align-middle text-center">Item</th>
              <th colSpan="2" className="text-center">Naden</th>
              <th colSpan="2" className="text-center">Delen</th>
              <th style={{ width: '8%' }} rowSpan="2" className="align-middle text-center">Actie</th>
            </tr>
            <tr>
              <th style={{ width: '20%' }} className="text-center">Status</th>
              <th style={{ width: '26%' }} className="text-center">Fotos</th>
              <th style={{ width: '20%' }} className="text-center">Status</th>
              <th style={{ width: '26%' }} className="text-center">Foto's</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center text-muted">
                  Geen items toegevoegd. Klik op "Rij Toevoegen" om te beginnen.
                </td>
              </tr>
            ) : (
              rows.map((row, index) => (
                <tr key={index}>
                  <td className="align-middle text-center">
                    <strong>{row.item_number}</strong>
                  </td>
                  <td>
                    <select
                      className="form-control form-control-sm"
                      value={row.status_droog}
                      onChange={(e) => handleRowChange(index, 'status_droog', e.target.value)}
                    >
                      <option value="">-- Selecteer --</option>
                      <option value="ok">OK</option>
                      <option value="niet_ok"></option>
                    </select>
                  </td>
                  <td>
                    <input
                      type="file"
                      className="form-control form-control-sm"
                      accept="image/*"
                      multiple
                      onChange={async (e) => {
                        const files = Array.from(e.target.files);
                        if (files.length > 0) {
                          const uploadedPhotos = [];

                          for (const file of files) {
                            const uploadedPhoto = await uploadPhotoToServer(file);
                            if (uploadedPhoto) {
                              uploadedPhotos.push(uploadedPhoto);
                            }
                          }

                          if (uploadedPhotos.length > 0) {
                            // Add to existing photos
                            const existingPhotos = Array.isArray(row.photo_droog) ? row.photo_droog : row.photo_droog ? [row.photo_droog] : [];
                            const updatedPhotos = [...existingPhotos, ...uploadedPhotos];
                            handleRowChange(index, 'photo_droog', updatedPhotos);
                          }
                        }
                        // Reset file input
                        e.target.value = '';
                      }}
                    />
                    {(() => {
                      const photos = Array.isArray(row.photo_droog) ? row.photo_droog : row.photo_droog ? [row.photo_droog] : [];
                      return photos.length > 0 && (
                        <div className="mt-2">
                          <div className="row">
                            {photos.map((photo, photoIndex) => (
                              <div key={photoIndex} className="col-12 mb-2">
                                <div className="d-flex align-items-start" style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '4px' }}>
                                  <img
                                    src={photo.thumbnail?.small || photo.image}
                                    alt={`Foto droog ${photoIndex + 1}`}
                                    style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '4px', cursor: 'pointer', marginRight: '8px' }}
                                    onClick={() => window.open(photo.image, '_blank')}
                                    title="Klik om te vergroten"
                                  />
                                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                    <small className="text-success d-block">
                                      <i className="fas fa-check-circle mr-1"></i>
                                      {photo.filename || photo.originalname || 'Foto geüpload'}
                                    </small>
                                  </div>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger"
                                    onClick={() => {
                                      if (window.confirm('Weet je zeker dat je deze foto wilt verwijderen?')) {
                                        const updatedPhotos = photos.filter((_, idx) => idx !== photoIndex);
                                        handleRowChange(index, 'photo_droog', updatedPhotos.length > 0 ? updatedPhotos : null);
                                      }
                                    }}
                                    title="Verwijder foto"
                                    style={{ flexShrink: 0 }}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                          <small className="text-muted">
                            {photos.length} {photos.length === 1 ? 'foto' : "foto's"}
                          </small>
                        </div>
                      );
                    })()}
                  </td>
                  <td>
                    <select
                      className="form-control form-control-sm"
                      value={row.status_nat}
                      onChange={(e) => handleRowChange(index, 'status_nat', e.target.value)}
                    >
                      <option value="">-- Selecteer --</option>
                      <option value="ok">OK</option>
                      <option value="niet_ok">Niet OK</option>
                    </select>
                  </td>
                  <td>
                    <input
                      type="file"
                      className="form-control form-control-sm"
                      accept="image/*"
                      multiple
                      onChange={async (e) => {
                        const files = Array.from(e.target.files);
                        if (files.length > 0) {
                          const uploadedPhotos = [];

                          for (const file of files) {
                            const uploadedPhoto = await uploadPhotoToServer(file);
                            if (uploadedPhoto) {
                              uploadedPhotos.push(uploadedPhoto);
                            }
                          }

                          if (uploadedPhotos.length > 0) {
                            // Add to existing photos
                            const existingPhotos = Array.isArray(row.photo_nat) ? row.photo_nat : row.photo_nat ? [row.photo_nat] : [];
                            const updatedPhotos = [...existingPhotos, ...uploadedPhotos];
                            handleRowChange(index, 'photo_nat', updatedPhotos);
                          }
                        }
                        // Reset file input
                        e.target.value = '';
                      }}
                    />
                    {(() => {
                      const photos = Array.isArray(row.photo_nat) ? row.photo_nat : row.photo_nat ? [row.photo_nat] : [];
                      return photos.length > 0 && (
                        <div className="mt-2">
                          <div className="row">
                            {photos.map((photo, photoIndex) => (
                              <div key={photoIndex} className="col-12 mb-2">
                                <div className="d-flex align-items-start" style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '4px' }}>
                                  <img
                                    src={photo.thumbnail?.small || photo.image}
                                    alt={`Foto nat ${photoIndex + 1}`}
                                    style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '4px', cursor: 'pointer', marginRight: '8px' }}
                                    onClick={() => window.open(photo.image, '_blank')}
                                    title="Klik om te vergroten"
                                  />
                                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                    <small className="text-success d-block">
                                      <i className="fas fa-check-circle mr-1"></i>
                                      {photo.filename || photo.originalname || 'Foto geüpload'}
                                    </small>
                                  </div>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger"
                                    onClick={() => {
                                      if (window.confirm('Weet je zeker dat je deze foto wilt verwijderen?')) {
                                        const updatedPhotos = photos.filter((_, idx) => idx !== photoIndex);
                                        handleRowChange(index, 'photo_nat', updatedPhotos.length > 0 ? updatedPhotos : null);
                                      }
                                    }}
                                    title="Verwijder foto"
                                    style={{ flexShrink: 0 }}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                          <small className="text-muted">
                            {photos.length} {photos.length === 1 ? 'foto' : "foto's"}
                          </small>
                        </div>
                      );
                    })()}
                  </td>
                  <td className="text-center align-middle">
                    <button
                      type="button"
                      className="btn btn-sm btn-danger"
                      onClick={() => handleRemoveRow(index)}
                      title="Verwijder rij"
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <button
        type="button"
        className="btn btn-primary btn-sm"
        onClick={handleAddRow}
      >
        <i className="fas fa-plus mr-2"></i>
        Rij Toevoegen
      </button>
    </div>
  );
};

const renderBevindingenField = ({ input, meta }) => {
  const value = input.value || {
    status: '',
    rows: []
  };

  const rows = value.rows || [];

  const handleAddRow = () => {
    const newRow = {
      bevindingen: '',
      risico: '',
      foto: []
    };
    input.onChange({
      ...value,
      rows: [...rows, newRow]
    });
  };

  const handleRemoveRow = (index) => {
    if (window.confirm('Weet je zeker dat je deze bevinding wilt verwijderen?')) {
      const updatedRows = rows.filter((_, idx) => idx !== index);
      input.onChange({
        ...value,
        rows: updatedRows
      });
    }
  };

  const handleRowChange = async (index, field, fieldValue) => {
    // If it's a file upload, upload it first
    if (field === 'foto' && fieldValue instanceof File) {
      const uploadedPhoto = await uploadPhotoToServer(fieldValue);
      if (uploadedPhoto) {
        fieldValue = uploadedPhoto;
      } else {
        return; // Upload failed, don't update the field
      }
    }

    const updatedRows = [...rows];
    updatedRows[index] = {
      ...updatedRows[index],
      [field]: fieldValue
    };
    input.onChange({
      ...value,
      rows: updatedRows
    });
  };

  return (
    <div className="bevindingen-form">
      {rows.length === 0 && (
        <div className="alert alert-info py-2 mb-3">
          <small>
            <i className="fas fa-info-circle mr-1"></i>
            Klik op "Bevinding toevoegen" om een nieuwe bevinding toe te voegen.
          </small>
        </div>
      )}

      {rows.map((row, index) => (
        <div key={index} className="card mb-3">
          <div className="card-header bg-light py-2 d-flex justify-content-between align-items-center">
            <strong>Bevinding #{index + 1}</strong>
            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={() => handleRemoveRow(index)}
              title="Verwijder bevinding"
            >
              <i className="fas fa-trash"></i> Verwijderen
            </button>
          </div>
          <div className="card-body">
            <div className="form-group mb-2">
              <label className="font-weight-bold mb-1">Bevindingen</label>
              <textarea
                className="form-control form-control-sm"
                rows="3"
                value={row.bevindingen || ''}
                onChange={(e) => handleRowChange(index, 'bevindingen', e.target.value)}
                placeholder="Beschrijf de bevindingen..."
              />
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group mb-2">
                  <label className="font-weight-bold mb-1">Risico (1-5)</label>
                  <select
                    className="form-control form-control-sm"
                    value={row.risico || ''}
                    onChange={(e) => handleRowChange(index, 'risico', e.target.value)}
                  >
                    <option value="">-- Selecteer --</option>
                    <option value="1">1 - Zeer hoog</option>
                    <option value="2">2 - Hoog</option>
                    <option value="3">3 - Gemiddeld</option>
                    <option value="4">4 - Laag</option>
                    <option value="5">5 - Zeer laag</option>
                  </select>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group mb-2">
                  <label className="font-weight-bold mb-1">Foto's</label>
                  <input
                    type="file"
                    className="form-control form-control-sm"
                    accept="image/*"
                    multiple
                    onChange={async (e) => {
                      const files = Array.from(e.target.files);
                      if (files.length > 0) {
                        const uploadedPhotos = [];

                        for (const file of files) {
                          const uploadedPhoto = await uploadPhotoToServer(file);
                          if (uploadedPhoto) {
                            uploadedPhotos.push(uploadedPhoto);
                          }
                        }

                        if (uploadedPhotos.length > 0) {
                          // Add to existing photos
                          const existingPhotos = Array.isArray(row.foto) ? row.foto : row.foto ? [row.foto] : [];
                          const updatedPhotos = [...existingPhotos, ...uploadedPhotos];
                          handleRowChange(index, 'foto', updatedPhotos);
                        }
                      }
                      // Reset file input
                      e.target.value = '';
                    }}
                  />
                  {(() => {
                    const photos = Array.isArray(row.foto) ? row.foto : row.foto ? [row.foto] : [];
                    return photos.length > 0 && (
                      <div className="mt-2">
                        <div className="row">
                          {photos.map((photo, photoIndex) => (
                            <div key={photoIndex} className="col-md-6 col-12 mb-2">
                              <div className="d-flex align-items-start" style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '4px' }}>
                                <img
                                  src={photo.thumbnail?.small || photo.image}
                                  alt={`Bevindingen foto ${photoIndex + 1}`}
                                  style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '4px', cursor: 'pointer', marginRight: '8px' }}
                                  onClick={() => window.open(photo.image, '_blank')}
                                  title="Klik om te vergroten"
                                />
                                <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                  <small className="text-success d-block">
                                    <i className="fas fa-check-circle mr-1"></i>
                                    {photo.filename || photo.originalname || 'Foto geüpload'}
                                  </small>
                                </div>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  onClick={() => {
                                    if (window.confirm('Weet je zeker dat je deze foto wilt verwijderen?')) {
                                      const updatedPhotos = photos.filter((_, idx) => idx !== photoIndex);
                                      handleRowChange(index, 'foto', updatedPhotos.length > 0 ? updatedPhotos : []);
                                    }
                                  }}
                                  title="Verwijder foto"
                                  style={{ flexShrink: 0 }}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </div>
                            </div>
                          ))}
                        </div>
                        <small className="text-muted">
                          {photos.length} {photos.length === 1 ? 'foto' : "foto's"}
                        </small>
                      </div>
                    );
                  })()}
                </div>
              </div>
            </div>

            {row.risico && parseInt(row.risico) <= 2 && (
              <div className="alert alert-warning mb-0 mt-2 py-2">
                <small>
                  <i className="fas fa-exclamation-triangle mr-1"></i>
                  <strong>Hoog risico:</strong> Voeg een foto en duidelijke beschrijving toe.
                </small>
              </div>
            )}
          </div>
        </div>
      ))}

      <button
        type="button"
        className="btn btn-primary btn-sm"
        onClick={handleAddRow}
      >
        <i className="fas fa-plus mr-1"></i> Bevinding toevoegen
      </button>
    </div>
  );
};

const renderInspectieonderdelenField = ({ input, meta, item }) => {
  const value = input.value || {
    scores: [],
    tests: []
  };

  const predefinedRows = item.inspectieonderdelen_rows || [];
  const scores = value.scores || [];
  const tests = value.tests || [];

  const handleScoreChange = (rowIndex, score) => {
    const newScores = [...scores];
    newScores[rowIndex] = score;

    // Clear test field if score is not 2
    const newTests = [...tests];
    if (score !== '2') {
      newTests[rowIndex] = '';
    }

    const newValue = {
      ...value,
      scores: newScores,
      tests: newTests
    };
    input.onChange(newValue);
  };

  const handleTestChange = (rowIndex, test) => {
    const newTests = [...tests];
    newTests[rowIndex] = test;
    const newValue = {
      ...value,
      tests: newTests
    };
    input.onChange(newValue);
  };

  if (predefinedRows.length === 0) {
    return (
      <div className="alert alert-warning">
        <i className="fas fa-exclamation-triangle mr-2"></i>
        Geen inspectieonderdelen gedefinieerd in het sjabloon.
      </div>
    );
  }

  return (
    <div className="inspectieonderdelen-form">
      <div className="table-responsive">
        <table className="table table-bordered table-sm">
          <thead className="thead-light">
            <tr>
              <th style={{ width: '5%' }} className="text-center">Nr.</th>
              <th style={{ width: '30%' }}>Inspectieonderdeel</th>
              <th style={{ width: '40%' }}>Eis/Toelichting</th>
              <th style={{ width: '25%' }}>Score</th>
            </tr>
          </thead>
          <tbody>
            {predefinedRows.map((row, index) => {
              const currentScore = scores[index];
              const scoreNum = currentScore ? parseInt(currentScore) : 0;
              const requiresTest = scoreNum === 2;
              const isComplete = currentScore && (!requiresTest || (requiresTest && tests[index]));

              return (
                <React.Fragment key={index}>
                  <tr className={isComplete ? 'table-success' : ''}>
                    <td className="text-center align-middle font-weight-bold">
                      {index + 1}
                    </td>
                    <td className="align-middle">
                      <strong>{row.inspectieonderdeel}</strong>
                    </td>
                    <td className="align-middle">
                      <div style={{ fontSize: '0.9em', color: '#555' }}>
                        {row.eis_toelichting}
                      </div>
                    </td>
                    <td>
                      <select
                        className="form-control form-control-sm"
                        value={scores[index] || ''}
                        onChange={(e) => handleScoreChange(index, e.target.value)}
                      >
                        <option value="">-- Selecteer --</option>
                        <option value="1">1 (goed)</option>
                        <option value="2">2 (gemiddeld)</option>
                        <option value="3">3 (nvt)</option>
                      </select>
                    </td>
                  </tr>
                  {requiresTest && (
                    <tr className={isComplete ? 'table-success' : ''}>
                      <td></td>
                      <td colSpan="3">
                        <div className="form-group mb-0">
                          <label className="mb-1 small font-weight-bold text-primary">
                            <i className="fas fa-flask mr-1"></i>
                            Test * (vereist bij score 2)
                          </label>
                          <textarea
                            className="form-control form-control-sm"
                            rows="3"
                            value={tests[index] || ''}
                            onChange={(e) => handleTestChange(index, e.target.value)}
                            placeholder="Beschrijf de test..."
                          />
                        </div>
                      </td>
                    </tr>
                  )}
                  {isComplete && (
                    <tr className="table-success">
                      <td></td>
                      <td colSpan="3" className="text-center py-2">
                        <span className="badge badge-success">
                          <i className="fas fa-check-circle mr-1"></i>
                          Voltooid
                        </span>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="text-muted small mt-2">
        <i className="fas fa-info-circle mr-1"></i>
        Vul voor elk item een score in. Score 1 = goed, 2 = gemiddeld, 3 = nvt. Bij score 2 moet ook een test worden beschreven.
      </div>
    </div>
  );
};

const InspectionExecutePage = (props) => {
  const { handleSubmit, dispatch, initialize, inspection } = props;
  const navigate = useNavigate();
  const { id } = useParams();

  const [activeTab, setActiveTab] = useState(0);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [lastSaved, setLastSaved] = useState(null);
  const [completedChapters, setCompletedChapters] = useState({});
  const [showCompleted, setShowCompleted] = useState(false);
  const [uploadingFiles, setUploadingFiles] = useState({});
  const [uploadingReportPhoto, setUploadingReportPhoto] = useState(false);

  useEffect(() => {
    if (id) {
      dispatch(getInspection(id)).then(() => {
        setLoading(false);
      });
    }
  }, [dispatch, id]);

  useEffect(() => {
    // Support both template_id (new) and template_ids (old) for backwards compatibility
    if (inspection) {
      let templateIdToFetch = null;

      if (inspection.template_id) {
        // New format: single template_id
        templateIdToFetch = typeof inspection.template_id === 'object'
          ? inspection.template_id._id
          : inspection.template_id;
      } else if (inspection.template_ids && inspection.template_ids.length > 0) {
        // Old format: template_ids array - use first one
        templateIdToFetch = typeof inspection.template_ids[0] === 'object'
          ? inspection.template_ids[0]._id
          : inspection.template_ids[0];
      }

      if (templateIdToFetch) {
        fetchTemplateDetails(templateIdToFetch);
      } else {
        alert('Geen sjabloon gevonden voor deze inspectie. Controleer de inspectie data.');
      }
    }
  }, [inspection]);

  const fetchTemplateDetails = async (templateId) => {
    try {
      const response = await fetch(`/api/inspection-templates/templates/${templateId}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      const data = await response.json();

      const itemsResponse = await fetch(`/api/inspection-templates/templates/${templateId}/items`, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      const itemsData = await itemsResponse.json();

      const templateData = {
        ...data.result,
        items: itemsData.results || []
      };

      const templatesData = [templateData];
      setTemplates(templatesData);

      // Initialize form data after templates are loaded
      // Use setTimeout to ensure templates state is updated before initializing form
      setTimeout(() => {
        // Check if we have saved data to load
        if (inspection.inspection_data && Object.keys(inspection.inspection_data).length > 0) {

          // Load completed chapters
          if (inspection.inspection_data._completed_chapters) {
            setCompletedChapters(inspection.inspection_data._completed_chapters);
          }

          // Ensure arrays are properly initialized for inspectieonderdelen
          const dataToLoad = { ...inspection.inspection_data };
          templatesData.forEach(template => {
            template.items.forEach(item => {
              const fieldName = `${template._id}_${item._id}`;
              if (item.item_template_id === 'inspectieonderdelen') {
                // Ensure the field has the correct structure
                if (!dataToLoad[fieldName] || typeof dataToLoad[fieldName] !== 'object') {
                  dataToLoad[fieldName] = { scores: [], constateringen: [] };
                } else {
                  // Ensure scores and constateringen are arrays
                  if (!Array.isArray(dataToLoad[fieldName].scores)) {
                    dataToLoad[fieldName].scores = [];
                  }
                  if (!Array.isArray(dataToLoad[fieldName].constateringen)) {
                    dataToLoad[fieldName].constateringen = [];
                  }
                }
              }
            });
          });

          initialize(dataToLoad);
        } else {
          // No saved data, create empty initial values
          const initialData = {};

          templatesData.forEach(template => {
            template.items.forEach(item => {
              const fieldName = `${template._id}_${item._id}`;

              // Default empty value based on item type
              if (item.item_template_id === 'schaal_delen_glijdelen') {
                initialData[fieldName] = { rows: [] };
              } else if (item.item_template_id === 'bevindingen') {
                // Bevindingen items get status inside the value object (matching mobile app structure)
                initialData[fieldName] = { status: '', rows: [] };
              } else if (item.item_template_id === 'inspectieonderdelen') {
                // Inspectieonderdelen items
                initialData[fieldName] = { scores: [], tests: [], photos: [] };
              } else if (item.input_type === 'checkbox') {
                initialData[fieldName] = false;
              } else {
                initialData[fieldName] = '';
              }
            });
          });

          initialize(initialData);
        }
      }, 100);
    } catch (error) {
      console.error('❌ Fout bij ophalen template details:', error);
      alert('Fout bij laden van template: ' + error.message);
    }
  };

  // Auto-save with Redux Form (including when completedChapters changes)
  useEffect(() => {
    if (!props.formValues || Object.keys(props.formValues).length === 0) return;

    const timer = setTimeout(() => {
      autoSave(props.formValues);
    }, 2000);

    return () => clearTimeout(timer);
  }, [props.formValues, completedChapters]);

  const autoSave = async (formValues) => {
    if (!id || !formValues) return;

    setIsSaving(true);
    try {
      const dataToSave = {
        ...formValues,
        _completed_chapters: completedChapters
      };

      const response = await fetch(`/api/inspections/inspections/${id}/autosave`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem("token"),
        },
        body: JSON.stringify({
          inspection_data: dataToSave,
          status: 'in_progress'
        })
      });

      const data = await response.json();
      if (data.success) {
        setLastSaved(new Date());
      }
    } catch (error) {
      // Auto-save failed silently
    } finally {
      setIsSaving(false);
    }
  };

  const onSubmit = async (values) => {
    setIsSaving(true);
    try {
      const response = await fetch(`/api/inspections/inspections/${id}/autosave`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem("token"),
        },
        body: JSON.stringify({
          inspection_data: values,
          status: 'in_progress'
        })
      });

      const data = await response.json();
      if (data.success) {
        setLastSaved(new Date());
        alert('Inspectie opgeslagen!');
      }
    } catch (error) {
      console.error('Fout bij opslaan:', error);
      alert('Er is een fout opgetreden bij het opslaan');
    } finally {
      setIsSaving(false);
    }
  };

  const handleComplete = async () => {
    if (!window.confirm('Weet je zeker dat je deze inspectie wilt voltooien?')) {
      return;
    }

    try {
      const response = await fetch(`/api/inspections/inspections/${id}/complete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem("token"),
        },
        body: JSON.stringify({
          inspection_data: props.formValues
        })
      });

      const data = await response.json();
      if (data.success) {
        alert('Inspectie voltooid!');
        navigate('/zwembadinspecties/inspecties');
      }
    } catch (error) {
      console.error('Fout bij voltooien:', error);
      alert('Er is een fout opgetreden bij het voltooien');
    }
  };

  const toggleChapterComplete = (templateId, chapterId) => {
    const key = `${templateId}_${chapterId}`;
    setCompletedChapters(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const uploadPhoto = async (file, fieldName) => {
    if (!file) return null;

    setUploadingFiles(prev => ({ ...prev, [fieldName]: true }));

    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch('/api/inspections/upload-photo', {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem("token"),
        },
        body: formData
      });

      const data = await response.json();

      if (data.success) {
        return data.result;
      } else {
        throw new Error(data.message || 'Upload failed');
      }
    } catch (error) {
      alert('Fout bij uploaden foto: ' + error.message);
      return null;
    } finally {
      setUploadingFiles(prev => ({ ...prev, [fieldName]: false }));
    }
  };

  const handleUploadReportPhoto = async (file) => {
    if (!file) return;

    setUploadingReportPhoto(true);
    try {
      await dispatch(uploadReportPhoto(id, file));
      alert('Rapport foto succesvol geüpload!');
    } catch (error) {
      alert('Fout bij uploaden rapport foto');
    } finally {
      setUploadingReportPhoto(false);
    }
  };

  const handleDeleteReportPhoto = async () => {
    if (!window.confirm('Weet je zeker dat je de rapport foto wilt verwijderen?')) {
      return;
    }

    try {
      await dispatch(deleteReportPhoto(id));
      alert('Rapport foto succesvol verwijderd!');
    } catch (error) {
      alert('Fout bij verwijderen rapport foto');
    }
  };

  const renderInputField = (item, template) => {
    const fieldName = `${template._id}_${item._id}`;
    const statusFieldName = `${fieldName}_status`;

    // Special handling for templates
    if (item.item_template_id === 'schaal_delen_glijdelen') {
      return (
        <Field
          name={fieldName}
          component={renderSchaaldDelenField}
          templateId={template._id}
        />
      );
    }

    // Special handling for inspectieonderdelen template items
    if (item.item_template_id === 'inspectieonderdelen') {
      return (
        <Field
          name={fieldName}
          component={renderInspectieonderdelenField}
          item={item}
        />
      );
    }

    // Special handling for bevindingen template items
    if (item.item_template_id === 'bevindingen') {
      // Get current value (status is inside the value object, matching mobile app structure)
      const currentValue = props.formValues && props.formValues[fieldName];
      const currentStatus = currentValue?.status || '';

      const handleStatusChange = (status) => {
        if (status === 'ok') {
          // Clear rows when selecting OK
          dispatch(change('inspection_execute', fieldName, { status, rows: [], ok_na_bevindingen: null }));
        } else if (status === 'niet_ok') {
          // Add first row automatically when selecting Niet OK (if no rows exist)
          const rows = currentValue?.rows || [];
          if (rows.length === 0) {
            dispatch(change('inspection_execute', fieldName, {
              status,
              rows: [{ bevindingen: '', risico: '', foto: [] }],
              ok_na_bevindingen: null
            }));
          } else {
            dispatch(change('inspection_execute', fieldName, {
              ...currentValue,
              status,
              ok_na_bevindingen: null
            }));
          }
        } else if (status === 'ok_na_bevindingen') {
          // Initialize ok_na_bevindingen data
          dispatch(change('inspection_execute', fieldName, {
            status,
            rows: [],
            ok_na_bevindingen: currentValue?.ok_na_bevindingen || { reden: '', foto: [] }
          }));
        }
      };

      const handleOkNaBevindingenChange = async (field, fieldValue) => {
        const okNaBevindingen = currentValue?.ok_na_bevindingen || { reden: '', foto: [] };

        // If it's a file upload, upload it first
        if (field === 'foto' && fieldValue instanceof File) {
          const uploadedPhoto = await uploadPhotoToServer(fieldValue);
          if (uploadedPhoto) {
            fieldValue = uploadedPhoto;
          } else {
            return; // Upload failed, don't update the field
          }
        }

        dispatch(change('inspection_execute', fieldName, {
          ...currentValue,
          ok_na_bevindingen: {
            ...okNaBevindingen,
            [field]: fieldValue
          }
        }));
      };

      return (
        <div>
          {/* OK/Niet OK/OK na bevindingen status buttons */}
          <div className="mb-3">
            <div className="btn-group" role="group">
              <button
                type="button"
                className={`btn btn-sm ${currentStatus === 'ok' ? 'btn-success' : 'btn-outline-success'}`}
                onClick={() => handleStatusChange('ok')}
              >
                <i className="fas fa-check mr-1"></i>
                OK
              </button>
              <button
                type="button"
                className={`btn btn-sm ${currentStatus === 'ok_na_bevindingen' ? 'btn-warning' : 'btn-outline-warning'}`}
                onClick={() => handleStatusChange('ok_na_bevindingen')}
              >
                <i className="fas fa-check-double mr-1"></i>
                OK na bevindingen
              </button>
              <button
                type="button"
                className={`btn btn-sm ${currentStatus === 'niet_ok' ? 'btn-danger' : 'btn-outline-danger'}`}
                onClick={() => handleStatusChange('niet_ok')}
              >
                <i className="fas fa-times mr-1"></i>
                Niet OK
              </button>
            </div>
          </div>

          {/* Only show bevindingen form when status is selected */}
          {currentStatus === 'ok' && (
            <div className="alert alert-success">
              <i className="fas fa-check-circle mr-2"></i>
              Geen bevindingen - alles in orde
            </div>
          )}

          {currentStatus === 'ok_na_bevindingen' && (
            <div className="mt-3">
              <div className="card border-warning">
                <div className="card-header bg-warning text-dark">
                  <strong>
                    <i className="fas fa-check-double mr-2"></i>
                    OK na bevindingen
                  </strong>
                </div>
                <div className="card-body">
                  <div className="form-group mb-3">
                    <label className="font-weight-bold mb-1">Reden / Toelichting *</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={currentValue?.ok_na_bevindingen?.reden || ''}
                      onChange={(e) => handleOkNaBevindingenChange('reden', e.target.value)}
                      placeholder="Beschrijf wat er is opgelost of waarom het nu OK is..."
                    />
                  </div>

                  <div className="form-group mb-0">
                    <label className="font-weight-bold mb-1">Foto's (optioneel)</label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*"
                      multiple
                      onChange={async (e) => {
                        const files = Array.from(e.target.files);
                        if (files.length > 0) {
                          const uploadedPhotos = [];

                          for (const file of files) {
                            const uploadedPhoto = await uploadPhotoToServer(file);
                            if (uploadedPhoto) {
                              uploadedPhotos.push(uploadedPhoto);
                            }
                          }

                          if (uploadedPhotos.length > 0) {
                            const existingPhotos = Array.isArray(currentValue?.ok_na_bevindingen?.foto)
                              ? currentValue.ok_na_bevindingen.foto
                              : currentValue?.ok_na_bevindingen?.foto
                                ? [currentValue.ok_na_bevindingen.foto]
                                : [];
                            const updatedPhotos = [...existingPhotos, ...uploadedPhotos];
                            handleOkNaBevindingenChange('foto', updatedPhotos);
                          }
                        }
                        e.target.value = '';
                      }}
                    />
                    {(() => {
                      const photos = Array.isArray(currentValue?.ok_na_bevindingen?.foto)
                        ? currentValue.ok_na_bevindingen.foto
                        : currentValue?.ok_na_bevindingen?.foto
                          ? [currentValue.ok_na_bevindingen.foto]
                          : [];
                      return photos.length > 0 && (
                        <div className="mt-2">
                          <div className="row">
                            {photos.map((photo, photoIndex) => (
                              <div key={photoIndex} className="col-md-4 col-6 mb-2">
                                <div className="d-flex align-items-start" style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '4px' }}>
                                  <img
                                    src={photo.thumbnail?.small || photo.image}
                                    alt={`OK na bevindingen foto ${photoIndex + 1}`}
                                    style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '4px', cursor: 'pointer', marginRight: '8px' }}
                                    onClick={() => window.open(photo.image, '_blank')}
                                    title="Klik om te vergroten"
                                  />
                                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                    <small className="text-success d-block">
                                      <i className="fas fa-check-circle mr-1"></i>
                                      {photo.filename || photo.originalname || 'Foto geüpload'}
                                    </small>
                                  </div>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger"
                                    onClick={() => {
                                      if (window.confirm('Weet je zeker dat je deze foto wilt verwijderen?')) {
                                        const updatedPhotos = photos.filter((_, idx) => idx !== photoIndex);
                                        handleOkNaBevindingenChange('foto', updatedPhotos.length > 0 ? updatedPhotos : []);
                                      }
                                    }}
                                    title="Verwijder foto"
                                    style={{ flexShrink: 0 }}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                          <small className="text-muted">
                            {photos.length} {photos.length === 1 ? 'foto' : "foto's"}
                          </small>
                        </div>
                      );
                    })()}
                  </div>
                </div>
              </div>
            </div>
          )}

          {currentStatus === 'niet_ok' && (
            <div className="mt-3">
              <Field
                name={fieldName}
                component={renderBevindingenField}
              />
            </div>
          )}

          {!currentStatus && (
            <div className="alert alert-info">
              <i className="fas fa-info-circle mr-2"></i>
              Selecteer eerst OK, OK na bevindingen of Niet OK
            </div>
          )}
        </div>
      );
    }

    // Standard field types - no OK/Niet OK buttons for these
    switch (item.input_type) {
      case 'text':
        return (
          <Field
            name={fieldName}
            component={renderField}
            type="text"
            placeholder={item.help_text}
          />
        );

      case 'textarea':
        return (
          <Field
            name={fieldName}
            component={renderTextField}
            placeholder={item.help_text}
          />
        );

      case 'number':
        return (
          <Field
            name={fieldName}
            component={renderField}
            type="number"
            placeholder={item.help_text}
          />
        );

      case 'date':
        return (
          <Field
            name={fieldName}
            component={renderField}
            type="date"
          />
        );

      case 'checkbox':
        return (
          <Field
            name={fieldName}
            component={SwitcButton}
            label={item.help_text}
            defaultValue={false}
          />
        );

      case 'select':
        return (
          <Field
            name={fieldName}
            component="select"
            className="form-control"
          >
            <option value="">-- Maak een keuze --</option>
            {item.options && item.options.map((option, idx) => (
              <option key={idx} value={option.value}>
                {option.label}
              </option>
            ))}
          </Field>
        );

      case 'file':
        const photoData = props.formValues && props.formValues[fieldName];
        const photos = Array.isArray(photoData) ? photoData : photoData ? [photoData] : [];

        return (
          <div>
            <input
              type="file"
              className="form-control"
              accept="image/*"
              multiple
              onChange={async (e) => {
                const files = Array.from(e.target.files);
                if (files.length > 0) {
                  const uploadedPhotos = [];

                  for (const file of files) {
                    const uploadResult = await uploadPhoto(file, fieldName);
                    if (uploadResult) {
                      uploadedPhotos.push(uploadResult);
                    }
                  }

                  if (uploadedPhotos.length > 0) {
                    // Add to existing photos
                    const updatedPhotos = [...photos, ...uploadedPhotos];
                    dispatch(change('inspection_execute', fieldName, updatedPhotos));
                  }
                }
                // Reset file input
                e.target.value = '';
              }}
            />
            {uploadingFiles[fieldName] && (
              <small className="text-primary d-block mt-2">
                <i className="fas fa-spinner fa-spin mr-1"></i>
                Uploaden...
              </small>
            )}
            {photos.length > 0 && (
              <div className="mt-3">
                <div className="row">
                  {photos.map((photo, photoIndex) => (
                    <div key={photoIndex} className="col-md-4 col-sm-6 mb-3">
                      <div className="position-relative" style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '8px' }}>
                        <img
                          src={photo.thumbnail?.medium || photo.image}
                          alt={`Foto ${photoIndex + 1}`}
                          style={{ width: '100%', height: '150px', objectFit: 'cover', borderRadius: '4px', cursor: 'pointer' }}
                          onClick={() => window.open(photo.image, '_blank')}
                          title="Klik om te vergroten"
                        />
                        <small className="text-success d-block mt-2" style={{ fontSize: '0.85rem' }}>
                          <i className="fas fa-check-circle mr-1"></i>
                          {photo.filename || photo.originalname}
                        </small>
                        <button
                          type="button"
                          className="btn btn-sm btn-danger"
                          style={{ position: 'absolute', top: '4px', right: '4px' }}
                          onClick={() => {
                            if (window.confirm('Weet je zeker dat je deze foto wilt verwijderen?')) {
                              const updatedPhotos = photos.filter((_, idx) => idx !== photoIndex);
                              dispatch(change('inspection_execute', fieldName, updatedPhotos));
                            }
                          }}
                          title="Verwijder foto"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
                <small className="text-muted">
                  {photos.length} {photos.length === 1 ? 'foto' : "foto's"} toegevoegd
                </small>
              </div>
            )}
          </div>
        );

      default:
        return (
          <Field
            name={fieldName}
            component={renderField}
            type="text"
          />
        );
    }
  };

  const renderTemplateContent = (template) => {
    const itemsByChapter = {};

    template.chapters?.forEach(chapter => {
      itemsByChapter[chapter._id || chapter.sort_order] = {
        chapter: chapter,
        items: template.items.filter(item => item.chapter_id === (chapter._id || template.chapters.indexOf(chapter)))
      };
    });

    // Add special "Rapport Foto" chapter at the beginning
    const reportPhotoChapter = {
      _id: 'report_photo',
      title: 'Rapport Foto',
      description: 'Voeg een foto toe voor de voorpagina van het rapport',
      sort_order: -1
    };

    const hasReportPhoto = inspection && inspection.report_photo;

    // Calculate total chapters including report photo
    const totalChapters = Object.values(itemsByChapter).length + 1;
    const completedRegularChapters = Object.values(itemsByChapter).filter((chapterData) => {
      const chapterKey = `${template._id}_${chapterData.chapter._id || chapterData.chapter.sort_order}`;
      return completedChapters[chapterKey];
    }).length;
    const completedTotal = completedRegularChapters + (hasReportPhoto ? 1 : 0);

    return (
      <div className="template-content">
        <div className="mb-3 d-flex justify-content-between align-items-center">
          <div>
            <strong>Voltooide hoofdstukken:</strong>{' '}
            {completedTotal} / {totalChapters}
          </div>
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={() => setShowCompleted(!showCompleted)}
          >
            <i className={`fas fa-eye${showCompleted ? '-slash' : ''} mr-1`}></i>
            {showCompleted ? 'Verberg voltooide' : 'Toon voltooide'}
          </button>
        </div>

        {/* Render Report Photo Chapter */}
        {(!hasReportPhoto || showCompleted) && (
          <div className="chapter-section mb-4">
            <div className={`card ${hasReportPhoto ? 'border-success' : ''}`}>
              <div className={`card-header ${hasReportPhoto ? 'bg-success text-white' : 'bg-light'}`}>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="mb-0">
                      {hasReportPhoto && <i className="fas fa-check-circle mr-2"></i>}
                      0. {reportPhotoChapter.title}
                    </h5>
                    {reportPhotoChapter.description && (
                      <small className={hasReportPhoto ? 'text-white-50' : 'text-muted'}>
                        {reportPhotoChapter.description}
                      </small>
                    )}
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="d-flex align-items-center">
                  {hasReportPhoto ? (
                    <>
                      <img
                        src={inspection.report_photo.thumbnail?.small || inspection.report_photo.image}
                        alt="Rapport foto"
                        style={{
                          width: '60px',
                          height: '60px',
                          objectFit: 'cover',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          marginRight: '12px'
                        }}
                        onClick={() => window.open(inspection.report_photo.image, '_blank')}
                        title="Klik om te vergroten"
                      />
                      <div className="flex-grow-1">
                        <small className="d-block font-weight-bold text-success">
                          <i className="fas fa-check-circle mr-1"></i>
                          Foto toegevoegd
                        </small>
                        <small className="text-muted">{inspection.report_photo.filename}</small>
                      </div>
                      <div className="d-flex align-items-center" style={{ gap: '4px' }}>
                        <label
                          className="btn btn-sm btn-outline-secondary mb-0"
                          style={{
                            cursor: 'pointer',
                            width: '36px',
                            height: '36px',
                            padding: '0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0'
                          }}
                          title="Vervangen"
                        >
                          <i className="fas fa-sync"></i>
                          <input
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            onChange={(e) => {
                              if (e.target.files[0]) {
                                handleUploadReportPhoto(e.target.files[0]);
                              }
                            }}
                          />
                        </label>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger mb-0"
                          onClick={handleDeleteReportPhoto}
                          title="Verwijderen"
                          style={{
                            width: '36px',
                            height: '36px',
                            padding: '0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0'
                          }}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div style={{
                        width: '60px',
                        height: '60px',
                        backgroundColor: '#dee2e6',
                        borderRadius: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: '12px'
                      }}>
                        <i className="fas fa-image text-muted" style={{ fontSize: '24px' }}></i>
                      </div>
                      <div className="flex-grow-1">
                        <small className="d-block font-weight-bold">Voeg een foto toe</small>
                        <small className="text-muted">Deze foto wordt getoond op de voorpagina</small>
                      </div>
                      <label className="btn btn-sm btn-primary mb-0" style={{ cursor: 'pointer' }}>
                        <i className="fas fa-upload mr-1"></i>
                        Upload
                        <input
                          type="file"
                          accept="image/*"
                          style={{ display: 'none' }}
                          onChange={(e) => {
                            if (e.target.files[0]) {
                              handleUploadReportPhoto(e.target.files[0]);
                            }
                          }}
                        />
                      </label>
                    </>
                  )}
                  {uploadingReportPhoto && (
                    <div className="ml-2">
                      <div className="spinner-border spinner-border-sm text-primary" role="status">
                        <span className="sr-only">Uploaden...</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {Object.values(itemsByChapter).map((chapterData, index) => {
          const chapterKey = `${template._id}_${chapterData.chapter._id || chapterData.chapter.sort_order}`;
          const isCompleted = completedChapters[chapterKey];

          // Hide completed chapters if showCompleted is false
          if (isCompleted && !showCompleted) {
            return null;
          }

          return (
            <div key={index} className="chapter-section mb-4">
              <div className={`card ${isCompleted ? 'border-success' : ''}`}>
                <div className={`card-header ${isCompleted ? 'bg-success text-white' : 'bg-light'}`}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h5 className="mb-0">
                        {isCompleted && <i className="fas fa-check-circle mr-2"></i>}
                        {index + 1}. {chapterData.chapter.title}
                      </h5>
                      {chapterData.chapter.description && (
                        <div
                          className={`mt-2 ${isCompleted ? 'text-white-50' : 'text-muted'}`}
                          dangerouslySetInnerHTML={{ __html: chapterData.chapter.description }}
                        />
                      )}
                    </div>
                    <button
                      type="button"
                      className={`btn btn-sm ${isCompleted ? 'btn-light' : 'btn-success'}`}
                      onClick={() => toggleChapterComplete(template._id, chapterData.chapter._id || chapterData.chapter.sort_order)}
                      title={isCompleted ? 'Markeer als niet voltooid' : 'Markeer als voltooid'}
                    >
                      <i className={`fas fa-${isCompleted ? 'times' : 'check'} mr-1`}></i>
                      {isCompleted ? 'Heropen' : 'Voltooid'}
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  {chapterData.items.length === 0 ? (
                    <p className="text-muted">Geen items in dit hoofdstuk</p>
                  ) : (
                    chapterData.items.map((item, itemIndex) => (
                      <div key={item._id} className="form-group mb-4">
                        <label className="font-weight-bold">
                          {itemIndex + 1}. {item.question}
                          {item.is_required && <span className="text-danger ml-1">*</span>}
                        </label>
                        {item.help_text && item.input_type !== 'checkbox' && (
                          <small className="form-text text-muted d-block mb-2">
                            {item.help_text}
                          </small>
                        )}
                        {renderInputField(item, template)}
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="container-fluid">
        <div className="text-center mt-5">
          <div className="spinner-border" role="status">
            <span className="sr-only">Laden...</span>
          </div>
        </div>
      </div>
    );
  }

  if (!inspection) {
    return (
      <div className="container-fluid">
        <div className="alert alert-danger mt-3">
          Inspectie niet gevonden
        </div>
      </div>
    );
  }

  // Check if inspection is closed (completed or approved)
  const isInspectionClosed = inspection.status === 'completed' || inspection.status === 'approved';

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          {/* Warning for closed inspections */}
          {isInspectionClosed && (
            <div className="alert alert-warning mt-3 d-flex justify-content-between align-items-center">
              <div>
                <i className="fas fa-lock mr-2"></i>
                <strong>Deze inspectie is afgesloten en kan niet meer worden bewerkt.</strong>
                <p className="mb-0 mt-2">
                  De inspectie heeft de status '{inspection.status === 'completed' ? 'Voltooid' : 'Goedgekeurd'}'
                  en is daarom vergrendeld voor wijzigingen.
                  U kunt het rapport wel bekijken.
                </p>
              </div>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => navigate(`/zwembadinspecties/inspecties/${id}/rapport`)}
              >
                <i className="fas fa-file-alt mr-2"></i>
                Bekijk Rapport
              </button>
            </div>
          )}

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="card">
              <div className="card-header">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h3>
                      Inspectie Uitvoeren
                      {isInspectionClosed && (
                        <span className="badge badge-warning ml-2">
                          <i className="fas fa-lock mr-1"></i>
                          Afgesloten
                        </span>
                      )}
                    </h3>
                    <p className="mb-0 text-muted">
                      {inspection.company_id?.name} - {new Date(inspection.inspection_date).toLocaleDateString('nl-NL')}
                    </p>
                    {isSaving && (
                      <small className="text-primary d-block mt-1">
                        <i className="fas fa-spinner fa-spin mr-1"></i>
                        Opslaan...
                      </small>
                    )}
                    {!isSaving && lastSaved && (
                      <small className="text-success d-block mt-1">
                        <i className="fas fa-check-circle mr-1"></i>
                        Laatst opgeslagen: {lastSaved.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' })}
                      </small>
                    )}
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary mr-2"
                      onClick={() => navigate('/zwembadinspecties/inspecties')}
                    >
                      <i className="fas fa-arrow-left mr-2"></i>
                      Terug
                    </button>
                    {isInspectionClosed && (
                      <button
                        type="button"
                        className="btn btn-primary mr-2"
                        onClick={() => navigate(`/zwembadinspecties/inspecties/${id}/rapport`)}
                      >
                        <i className="fas fa-file-alt mr-2"></i>
                        Bekijk Rapport
                      </button>
                    )}
                    {!isInspectionClosed && (
                      <>
                        <button
                          type="submit"
                          className="btn btn-primary mr-2"
                        >
                          <i className="fas fa-save mr-2"></i>
                          Opslaan
                        </button>
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={handleComplete}
                        >
                          <i className="fas fa-check mr-2"></i>
                          Voltooien
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="card-body">
                <fieldset disabled={isInspectionClosed}>
                  {templates.length === 0 ? (
                    <div className="alert alert-warning">
                      Geen sjablonen gekoppeld aan deze inspectie
                    </div>
                  ) : (
                    <div>
                      <h4 className="mb-4">{templates[0].name}</h4>
                      {renderTemplateContent(templates[0])}
                    </div>
                  )}
                </fieldset>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

// Redux Form wrapper
let ReduxInspectionExecutePage = reduxForm({
  form: 'inspection_execute',
  enableReinitialize: true
})(InspectionExecutePage);

// Connect to get form values for auto-save and inspection data
ReduxInspectionExecutePage = connect((state) => {
  const inspection = state.zwembadinspecties.inspection;
  return {
    formValues: state.form?.inspection_execute?.values,
    inspection: inspection,
    initialValues: inspection?.inspection_data || {}
  };
})(ReduxInspectionExecutePage);

export default ReduxInspectionExecutePage;
